import React from "react";
import { Trash2, Undo2 } from "lucide-react";

export function SavedQuotesDrawer({ 
  show, 
  onClose, 
  quotes, 
  onLoad, 
  onDelete 
}) {
  if (!show) return null;
  
  return (
    <div className="fixed inset-0 z-40" data-testid="saved-quotes-drawer">
      <div className="absolute inset-0 bg-black/20" onClick={onClose} />
      <div className="absolute right-0 top-16 bottom-0 w-96 bg-white border-l border-slate-200 shadow-xl overflow-y-auto">
        <div className="p-6">
          <h3 className="text-lg font-semibold font-['Outfit'] mb-4">Saved Quotes</h3>
          {quotes.length === 0 ? (
            <p className="text-sm text-slate-500">No saved quotes yet.</p>
          ) : (
            <div className="space-y-2">
              {quotes.map(q => (
                <div key={q.id} className="p-3 border border-slate-200 rounded-lg hover:bg-slate-50 transition-all group">
                  <div className="flex items-center justify-between">
                    <button
                      data-testid={`load-quote-${q.id}`}
                      onClick={() => onLoad(q.id)}
                      className="text-left flex-1"
                    >
                      <div className="font-medium text-sm text-slate-900">{q.clientName || "Untitled"}</div>
                      <div className="text-xs text-slate-500">{q.quoteDate} &middot; {q.lineItems?.length || 0} items</div>
                    </button>
                    <button
                      data-testid={`delete-quote-${q.id}`}
                      onClick={(e) => { e.stopPropagation(); onDelete(q.id); }}
                      className="opacity-0 group-hover:opacity-100 p-1.5 text-slate-400 hover:text-red-500 transition-all"
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function NewQuoteConfirmDialog({ 
  show, 
  onClose, 
  onConfirm 
}) {
  if (!show) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" data-testid="new-quote-confirm">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full mx-4">
        <h3 className="text-lg font-semibold mb-2">Start New Quote?</h3>
        <p className="text-sm text-slate-600 mb-5">This will clear your current line items. Make sure to save first.</p>
        <div className="flex gap-2 justify-end">
          <button 
            data-testid="new-quote-cancel" 
            onClick={onClose} 
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50"
          >
            Cancel
          </button>
          <button 
            data-testid="new-quote-confirm-btn" 
            onClick={onConfirm} 
            className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600"
          >
            Clear & Start New
          </button>
        </div>
      </div>
    </div>
  );
}

export function UndoBanner({ 
  item, 
  onUndo 
}) {
  if (!item) return null;
  
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-slate-900 text-white px-5 py-3 rounded-xl shadow-2xl flex items-center gap-3 text-sm" data-testid="undo-banner">
      <span>Removed {item.state}/{item.wcCode}</span>
      <button 
        data-testid="undo-btn" 
        onClick={onUndo} 
        className="flex items-center gap-1 text-[#3c68ff] font-semibold hover:text-blue-300 transition-colors"
      >
        <Undo2 size={14} /> Undo
      </button>
    </div>
  );
}
